import slackIcon from '../../assets/img/icons/svg/slack.svg';
import gmailIcon from '../../assets/img/icons/svg/gmail.svg';

export const APPROVAL_CHANNELS = [
  {
    id: 'slack',
    label: 'Slack',
    match: ['slack'],
    icon: slackIcon,
    oauth: true,
    oauthLabel: 'Slack OAuth',
    providers: ['SLACK'],
  },
  {
    id: 'gmail',
    label: 'Gmail',
    match: ['gmail'],
    icon: gmailIcon,
    oauth: true,
    oauthLabel: 'Gmail OAuth',
    providers: ['GMAIL', 'GOOGLE'],
  },
];

export const APPROVAL_CHANNEL_META = Object.fromEntries(
  APPROVAL_CHANNELS.map(({ id, label, icon }) => [id, { label, icon }])
);
